// Pure helpers ported from the legacy getClientJS (worker.js). Behavior
// preserved exactly; regex un-escaped from the template-literal doubling.

export function normalizeDate(dateStr?: string | null): string {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) {
    if (/^\d{1,2}\/\d{1,2}\/\d{2}$/.test(dateStr)) return dateStr;
    return dateStr;
  }
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const year = date.getFullYear().toString().slice(-2);
  return `${month}/${day}/${year}`;
}

export function formatDateTime(dateStr?: string | null): string {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return dateStr;
  const centralDate = new Date(date.toLocaleString("en-US", { timeZone: "America/Chicago" }));
  const month = (centralDate.getMonth() + 1).toString().padStart(2, "0");
  const day = centralDate.getDate().toString().padStart(2, "0");
  let hours = centralDate.getHours();
  const minutes = centralDate.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours ? hours : 12;
  return `${month}/${day} ${hours}:${minutes} ${ampm}`;
}

export function expandTwinCheckRanges(input: string): string {
  if (!input || !input.trim()) return input;
  const parts = input.split(/\s+/);
  const expanded: string[] = [];
  for (const part of parts) {
    if (part.includes("-")) {
      const rangeParts = part.split("-").map((p) => p.trim());
      if (rangeParts.length === 2) {
        const startStr = rangeParts[0];
        const endStr = rangeParts[1];
        const start = parseInt(startStr);
        const end = parseInt(endStr);
        const padLength = Math.max(startStr.length, endStr.length);
        if (!isNaN(start) && !isNaN(end) && end >= start) {
          for (let i = start; i <= end; i++) {
            expanded.push(i.toString().padStart(padLength, "0"));
          }
        } else {
          expanded.push(part);
        }
      } else {
        expanded.push(part);
      }
    } else {
      expanded.push(part);
    }
  }
  return expanded.join(" ");
}

export function escapeHtml(str?: string | null): string {
  if (!str) return "";
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

export function formatDetailDate(dateStr?: string | null): string {
  if (!dateStr) return "N/A";
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return dateStr;
  return date.toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "2-digit" });
}

export function formatDetailDateTime(dateStr?: string | null): string {
  if (!dateStr) return "N/A";
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return dateStr;
  return date.toLocaleString("en-US", {
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

export function getStatusClass(status?: string | null): string {
  if (!status) return "status-pending";
  const s = status.toLowerCase().replace(/\s+/g, "-");
  if (["pending", "in-progress", "in progress"].includes(s)) return "status-pending";
  if (
    ["delivered", "picked-up", "picked up", "mailed", "cut", "prepped", "ready to mail", "ready-to-mail"].includes(s)
  )
    return "status-delivered";
  if (["legacy", "legacy-order", "legacy order"].includes(s)) return "status-legacy";
  return "status-delivered";
}

export function getInitials(name?: string | null): string {
  if (!name) return "?";
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .substring(0, 2);
}

/** YYYY-MM-DD for `n` weeks ago / today (default orders date range = 8 weeks). */
export function isoWeeksAgo(weeks: number): string {
  const d = new Date();
  d.setDate(d.getDate() - weeks * 7);
  return d.toISOString().split("T")[0];
}
export function isoToday(): string {
  return new Date().toISOString().split("T")[0];
}
